module.exports = __webpack_public_path__ + "img/anime6.2a5a031c.png";